import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root',
})
export class IsssteService {
  private http = inject(HttpService);

  public talonPagosList = async () => await this.http.get(`/v1/issste/talon-pagos`, false).then((response: any) => response.data.content.sort());
  public talonPagosUpload = async (body: any) => await this.http.post(`/v1/issste/talon-pagos`, body).then((response: any) => response.data);

  public constanciaAcreditacionNoAfiliacionList = async () => await this.http.get(`/v1/issste/constancia-acreditacion-no-afiliacion`, false).then((response: any) => response.data.content.sort());
  public constanciaAcreditacionNoAfiliacionUpload = async (body: any) => await this.http.post(`/v1/issste/constancia-acreditacion-no-afiliacion`, body).then((response: any) => response.data);
}
